"use strict";

import EventEmitter from 'eventemitter2';
import Browser from '../util/browser'

class Gnav extends EventEmitter{
	constructor($con){
		super();		
		this.$con = $con;
		this.isOpen = false;
		
		this.$con.find('.sanpo').on('click',()=>{ this.navClick('TabSanpo'); });
		this.$con.find('.zoom').on('click',()=>{ this.navClick('TabZoom'); });
	}
	
	open(){
		this.isOpen = true;
		this.$con.show();
		
		if(Browser.responsive == 'sp'){
			this.$con.velocity('stop').velocity({translateY:[0,'-100%']},{duration:400,easing:'swing'});
		} else {
			this.$con.find('.li1').velocity('stop').velocity({translateX:[0,'-100%']},{duration:400,easing:'swing'});
			this.$con.find('.li2').velocity('stop').velocity({translateX:[0,'100%']},{duration:400,easing:'swing'});
		}

	}
	
	clear(){
		this.$con.velocity('stop').removeAttr('style');
		this.$con.find('.li1').velocity('stop').removeAttr('style');
		this.$con.find('.li2').velocity('stop').removeAttr('style');
	}
	
	close(){
		this.isOpen = false;
		
		if(Browser.responsive == 'sp'){
			this.$con.velocity('stop').velocity({translateY:'-100%'},{duration:400,easing:'swing'
				,complete:()=>{
					this.$con.hide();
					this.clear();
				}
			});
		} else {
			this.$con.find('.li1').velocity('stop').velocity({translateX:'-100%'},{duration:400,easing:'swing'});
			this.$con.find('.li2').velocity('stop').velocity({translateX:'100%'},{duration:400,easing:'swing'
				,complete:()=>{
					this.$con.hide();
					this.clear();
				}
			});
		}
	}
	
	navClick(id){
		this.emit('nav_click' , id);
	}
	
}

export default Gnav;


// WEBPACK FOOTER //
// ./js/section/gnav.js